import {Component} from "inferno";
import {Card, CardBody, CardText} from "inferno-bootstrap";
import {Entity} from "../../../../utils/types";

export class TextBody extends Component<{ content: string, timestamp?: string, html: boolean, entity: Entity }> {

	body: HTMLElement;

	componentDidMount() {
		this.convertTarget(this.body);
	}

	convertTarget(node: Element) {
		if (node.nodeName === "A") {
			const link = node as HTMLLinkElement
			link.target = "_blank";
		}
		// tslint:disable-next-line:prefer-for-of
		for (let i = 0; i < node.children.length; i++) {
			this.convertTarget(node.children[i]);
		}
	}

	render() {
		const text = this.props.html ?
			<CardText className="mb-0" dangerouslySetInnerHTML={{__html: this.props.content}} /> :
			<CardText className="mb-0">{this.props.content}</CardText>;
		const css = this.props.entity === Entity.visitor ? "m-1 ml-5 v-bubble" : "bg-light m-1 mr-5 a-bubble";
		return (
			<Card className={css}>
				<div ref={(node: any) => this.body = node}>
					<CardBody className="p-2">
						{text}
						{this.props.timestamp && <CardText className="text-right">
							<small className="text-muted">{this.props.timestamp}</small>
						</CardText>}
					</CardBody>
				</div>
			</Card>
		);
	}
}
